'use strict';

import Forms from './forms/form';
import initSiteCopy from './templates/site-copy';

function initFormMasks() {
    Forms.maskFormFields();
    initSiteCopy();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormMasks);
} else {
    initFormMasks();
}

export function loadRecaptcha() {
    const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');
    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
    document.head.appendChild(script);
}

window.reloadCaptcha = function reloadCaptcha(action, fieldName = 'g-recaptcha-response', fn = null) {
    grecaptcha.ready(function () {
        const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');

        grecaptcha
            .execute(siteKey, {
                action: action,
            })
            .then(function (token) {
                const inputElement = document.querySelector("input[name='" + fieldName + "']");
                if (inputElement) {
                    inputElement.value = token;
                }

                if (fn) {
                    fn();
                }
            });
    });
};
